<template>
  <div class="product-attribute-container">
    <ThatsTable title="Product Attributes" ref="table" :endpoint="endpoint" :columns="columns"
      @openModal="openWindow" @deleteYes="deleteRows" @openUpdateModal="openUpdate">
      <template #customBtns>
        <mdb-btn color="elegant" icon="star-of-life" size="sm" class="mr-auto mt-0" @click="openBulkWindow">Bulk</mdb-btn>
      </template>
    </ThatsTable>
    <ProductAttributeForm ref="dialogForm" @success="refreshTable"></ProductAttributeForm>
    <ProductAttributeBulkForm ref="bulkForm" @success="refreshTable"></ProductAttributeBulkForm>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { mdbBtn } from 'mdbvue'
import ThatsTable from '../../components/thats/Table'
import ProductAttributeForm from './ProductAttributeForm'
import ProductAttributeBulkForm from './ProductAttributeBulkForm'

export default {
  components: { ThatsTable, ProductAttributeForm, ProductAttributeBulkForm, mdbBtn },
  data() {
    return { endpoint: 'product-attributes' }
  },
  computed: {
    ...mapGetters('ProductAttributeModule', ['columns']),
  },
  methods: {
    ...mapActions('ProductAttributeModule', ['deleteRecord']),
    ...mapMutations('ProductAttributeModule', ['setFormRecord', 'setFormStatusUpdate']),
    openWindow() {
      this.$refs.dialogForm.openDialog()
    },
    openBulkWindow() {
      this.$refs.bulkForm.openDialog()
    },
    openUpdate(record) {
      this.setFormStatusUpdate()
      this.setFormRecord(record)
      this.openWindow()
    },
    deleteRows(rows) {
      this.deleteRecord(rows).then(() => this.refreshTable())
    },
    refreshTable() {
      this.$refs.table.refreshTable()
    },
  },
}
</script>

<style scoped>
.product-attribute-container {
  position: relative;
  min-height: 340px;
}
</style>
